import { useCallback, useEffect, useMemo } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import {
  fetchAwbHistory,
  getAwbStatuses,
} from "../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  awbHistoryTableHeader,
  getAwbTableData,
} from "./tableConfigs/awbHistoryTableConfig";
import AwbHistoryActionButtons from "./ActionButtons/AwbHistoryActionButtons";
import { fetchRoutesNomenclatures } from "../../../redux/api/transport.api";
import CustomHeaderComponent from "./Components/CustomHeaderComponent";
import { dateForDatabase } from "../../../utils/dateAndTime";

function AwbHistoryTable({ clientsNodesData }: { clientsNodesData: any[] }) {
  const dispatch = useAppDispatch();
  const {
    expedition: {
      awbHistory: {
        data: { data: dataAwb, total: totalAwb },
        isLoading: isLoadingAwb,
      },
      clients: { data: clientsData },
      awbStatuses: { data: awbStatusesData, isLoading: isLoadingAwbStatus },
    },
    transport: {
      routesNomenclatures: {
        data: { data: routesNomenclatures },
        isLoading: isLoadingRoutesNomenclatures,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
    transport: state.transport,
  }));

  useEffect(() => {
    dispatch(getAwbStatuses());

    dispatch(
      fetchRoutesNomenclatures({
        perPage: 100,
      }),
    );
  }, [dispatch]);

  const getHistoryTableHeaderNew = useCallback(
    (initialTableData: any[]) => {
      return initialTableData.map((item) => {
        if (item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (item.value === "client") {
          const clientsDropdown = clientsData?.data.map(
            ({ denumireClient, idClient }) => ({
              label: denumireClient,
              value: idClient || 0,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: "all" }, ...clientsDropdown],
            ...item,
          };
        }
        if (!isLoadingAwbStatus && item.value === "status") {
          const awbStatusesDropdown = awbStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...awbStatusesDropdown,
            ],
            ...item,
          };
        }
        if (!isLoadingRoutesNomenclatures && item.value === "route") {
          const routesDropdown = routesNomenclatures?.map(
            ({ denumire, id_ruta }) => ({
              label: denumire,
              value: id_ruta,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...routesDropdown],
            ...item,
          };
        }

        return item;
      });
    },
    [
      awbStatusesData,
      clientsData?.data,
      clientsNodesData,
      isLoadingAwbStatus,
      isLoadingRoutesNomenclatures,
      routesNomenclatures,
    ],
  );

  const handleAwbTableActions = (action: TableActions) => {
    const formatDate = dateForDatabase(action.tableSearch.data_crearii);

    dispatch(
      fetchAwbHistory({
        page: action.tablePagination.page,
        perPage: action.tablePagination.rowsPerPage,
        id_client: action.tableSearch.client,
        pctlivrare: action.tableSearch.pctlivrare,
        nodDestinatie: action.tableSearch.nodDestinatie,
        status: action.tableSearch.status,
        doc_trans: action.tableSearch.doc_trans,
        route: action.tableSearch.route,
        coldFilter: action.tableSearch.coldFilter,
        data_crearii: formatDate,
      }),
    );
  };

  const awbHistoryTableHeaderNew = useMemo(
    () => getHistoryTableHeaderNew(awbHistoryTableHeader),
    [getHistoryTableHeaderNew],
  );

  return (
    <>
      <TableWidget
        CustomHeaderComponent={CustomHeaderComponent}
        tableHeaderData={awbHistoryTableHeaderNew}
        tableItemsData={getAwbTableData(dataAwb)}
        totalItems={totalAwb}
        tableLoading={isLoadingAwb}
        handleTableActions={handleAwbTableActions}
        ActionButtonsComponent={(props: any) => (
          <AwbHistoryActionButtons {...props} />
        )}
        borderedRow
      />
    </>
  );
}

export default AwbHistoryTable;
